import { render } from "./CardKitA.vue?vue&type=template&id=f39175c0"
import script from "./CardKitA.vue?vue&type=script&lang=js"
export * from "./CardKitA.vue?vue&type=script&lang=js"

import "./CardKitA.vue?vue&type=style&index=0&id=f39175c0&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__